import React, { useEffect, useState } from 'react';
import { Grid, Header, Popup } from 'semantic-ui-react';
import { CloseableContent, Icon, Notification, RecordsTable, STATUS_TYPES, Table } from 'dyl-components';
import { useDispatch, useSelector } from 'react-redux';
import TableRows from './subcomponents/TableRows';
import AddBillingContactForm from 'shared/forms/AddBillingContactForm';
import usersActions from 'actions/users';

import './index.scss';

export default function BillingContacts() {

    const dispatch = useDispatch();

    const { billing_contacts = [], isReadingBillingContacts, isDeletingBillingContacts } = useSelector((state) => {
        const contacts = state?.users?.billing_contacts || [];
        return {
            billing_contacts: [...contacts].sort((a, b) => b?.is_owner - a?.is_owner),
            isReadingBillingContacts: state?.users?.isReadingBillingContacts,
            isDeletingBillingContacts: state?.users?.isDeletingBillingContacts
        };
    });

    const [isAddBillingPopupOpen, setIsBillingPopupOpen] = useState(false)

    const onDeleteBillingContact = async (user_id) => {
        try {
            await dispatch(usersActions.deleteBillingContact(null, null, null, null, { user_ids: [user_id] }));
            Notification.alert("Successfully removed billing contact!", STATUS_TYPES.SUCCESS);
            dispatch(usersActions.getBillingContacts());
        } catch (e) {
            console.log(e);
            Notification.alert("Failed to remove billing contact", STATUS_TYPES.ERROR);
        }
    }

    useEffect(() => {
        dispatch(usersActions.getBillingContacts());
    }, [dispatch]);

    return (
        <Grid>
            <Grid.Row className='BillingContacts__toolbar'>
                <Grid.Column>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Header as='h2' color='primary'>
                            <span>
                                <Popup
                                    trigger={
                                        <Icon
                                            as='h2'
                                            className="fas fa-plus-circle"
                                            style={{ marginRight: 10, cursor: 'pointer' }}
                                            onClick={() => setIsBillingPopupOpen(true)}
                                        />
                                    }
                                    open={isAddBillingPopupOpen}
                                    onClose={() => setIsBillingPopupOpen(false)}
                                    closeOnDocumentClick={false}
                                    closeOnPortalMouseLeave={false}
                                    closeOnTriggerMouseLeave={false}
                                    content={
                                        <div style={{ marginTop: 10 }}>
                                            <Header color='primary'>Add Billing Contact
                                            </Header>
                                            <CloseableContent onClose={() => setIsBillingPopupOpen(false)} style={{ marginTop: 8 }}>
                                                <AddBillingContactForm onClose={() => setIsBillingPopupOpen(false)} />
                                            </CloseableContent>
                                        </div>
                                    }
                                    wide='very'
                                    style={{ width: '460px' }}
                                    position='bottom left'

                                />
                                Billing Contact
                                <Popup
                                    trigger={
                                        <Icon
                                            size='small'
                                            className='fas fa-circle-info'
                                            color='primary'
                                            style={{ marginLeft: 10, marginBottom: 2 }}
                                        />
                                    }
                                    content={<>Billing contacts will receive email invoices.</>}
                                    inverted
                                    flowing
                                    position='top center'
                                />
                            </span>
                        </Header>
                    </div>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row className='BillingContacts__table'>
                <Grid.Column width={6}>
                    <RecordsTable
                        tableBodyClassName="BillingContactsTable"
                        isTableLoading={isReadingBillingContacts || isDeletingBillingContacts}
                        isTableEmpty={billing_contacts?.length === 0}
                        noBorder
                        TableHeader={
                            <Table.Row>
                                <Table.HeaderCell width={13}>Contact</Table.HeaderCell>
                                <Table.HeaderCell width={3}>Actions</Table.HeaderCell>
                            </Table.Row>
                        }
                        TableRows={<TableRows billingContacts={billing_contacts} onDeleteBillingContact={onDeleteBillingContact} />}
                        hasPagination={false}
                        recordsName="Billing Contact"
                        emptySubtitle=""
                        emptyListTitle="No Billing Contacts Added"
                        emptySubtitleHidden
                    />
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
}
